var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrdersNoItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 188,
    viewBox: "0 0 157 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_9416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1406 156.497L74.8677 187.609L133.046 155.016L77.0931 125.378L21.1406 156.497Z",
    stroke: "#1A1A1A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8775 85.7894L80.2028 53.2834L54.4149 54.5761L0 87.789L24.8775 85.7894Z",
    fill: "url(#paint0_linear_1560_9416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.804 84.2005L80.2031 53.2834L96.5498 58.1782L150.351 89.075L132.804 84.2005Z",
    fill: "url(#paint1_linear_1560_9416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2022 60.6289V114.862L77.0934 116.302L24.877 85.7894L80.2022 53.2834V60.6289Z",
    fill: "#FFC629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2031 114.862L132.804 84.2005L80.2031 53.2834V114.862Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.093 116.302V164.974L22.7051 134.292L24.5663 85.3853L77.093 116.302Z",
    fill: "url(#paint2_linear_1560_9416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5674 85.3853L77.094 116.302L60.2213 143.267L6.00195 112.013L24.5674 85.3853Z",
    fill: "url(#paint3_linear_1560_9416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.09 132.38L77.0938 164.974V116.302L132.803 84.2004L135.09 132.38Z",
    fill: "#090A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0195 116.222L101.668 146.371L157 113.441L132.905 84.0725L77.0195 116.222Z",
    fill: "url(#paint4_linear_1560_9416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.8 84.2005C113.699 84.2005 121.724 76.1883 121.724 66.3047C121.724 56.4212 113.699 48.4089 103.8 48.4089C93.9002 48.4089 85.875 56.4212 85.875 66.3047C85.875 76.1883 93.9002 84.2005 103.8 84.2005Z",
    stroke: "#CC6C69",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4932 25.5713L26.3008 35.3204L58.3536 71.2533L73.4932 25.5713Z",
    stroke: "#EAEAEA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.278 5.47377L109.795 0L100.576 9.20374L91.3576 0L85.875 5.47377L95.0936 14.6775L85.875 23.8812L91.3576 29.355L100.576 20.1513L109.795 29.355L115.278 23.8812L106.059 14.6775L115.278 5.47377Z",
    fill: "url(#paint5_linear_1560_9416)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1560_9416",
    x1: 0,
    y1: 70.5396,
    x2: 80.2028,
    y2: 70.5396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5CA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F8D98F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FBEABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FDF5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFFCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FEFAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDF4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FBECC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F9E1AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F6D385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C358"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1560_9416",
    x1: 8422.9,
    y1: 3837.17,
    x2: 15719.7,
    y2: 3837.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5CA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F8D98F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FBEABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FDF5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFFCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FEFAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDF4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FBECC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F9E1AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F6D385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C358"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1560_9416",
    x1: 22.7051,
    y1: 125.183,
    x2: 77.093,
    y2: 125.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC6C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E4A15F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C358"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1560_9416",
    x1: 6.00195,
    y1: 114.33,
    x2: 77.094,
    y2: 114.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5CA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F8D98F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FBEABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FDF5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFFCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEFBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDF6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCEFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAE5AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F8DA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F5CC59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C237"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1560_9416",
    x1: 77.0195,
    y1: 115.225,
    x2: 157,
    y2: 115.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C237"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1560_9416",
    x1: 3829.99,
    y1: 639.939,
    x2: 5111.94,
    y2: 639.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC6C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E4A15F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C358"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_9416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 188,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersNoItem);
export default __webpack_public_path__ + "static/media/orders-no-item.f9fc9872c40224f16d622d0fcf1d0319.svg";
export { ForwardRef as ReactComponent };